module.exports = __webpack_public_path__ + "static/mobile-calendar-not-shown-cc694424d4255d8a4ad767cde802587d.png";